import clsx from 'clsx'
import PropTypes from 'prop-types'
import Markdown from 'react-markdown'
import { Columns, Column } from 'bloomer'
import { Vacancy } from 'components'
import { has } from 'lodash'

// Styles
import styles from './style.module.scss'

export const AvailableRoleList = ({ data, content, title, loading }) => {
  return (
    <div className={styles.available_roles}>
      <div className={clsx(styles.copy_wrapper)}>
        <Columns>
          <Column isSize={{ desktop: 10 }}>
            <h3 className={clsx('section-title', styles.section_title)}>{title}</h3>
            <Markdown source={content} className={clsx('section-copy', styles.section_copy)} />
          </Column>
        </Columns>
      </div>

      <div className={clsx(styles.list_wrapper)}>
        <Columns>
          <Column isSize={{ desktop: 12 }}>
            <ul className={styles.result_list}>
              {loading
                ? Array.from(Array(5).keys()).map(i => (
                    <li key={i} className={styles.result_item}>
                      <Vacancy.Skeleton />
                    </li>
                  ))
                : data.map(
                    item =>
                      has(item, 'content') && (
                        <li className={styles.result_item} key={item.id}>
                          <Vacancy.Item data={item.content} />
                        </li>
                      ),
                  )}
            </ul>
          </Column>
        </Columns>
      </div>
    </div>
  )
}

AvailableRoleList.propTypes = {
  data: PropTypes.array,
}

AvailableRoleList.defaultProps = {
  title: 'Title',
  content: 'The Content',
  data: [],
}

export default AvailableRoleList
